import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import { MainHeaderRight } from '../index'
import styles from './index.module.less'

export default ({
  renderLeft = null,
  children = undefined,
  renderRight = undefined,
  className = undefined,
  style = undefined,
  hiddenSearch = false,
}) => {
  return <div className={classNames(styles.customizeHeader, className)} style={style}>
    {renderLeft()}
    {renderRight ? renderRight() : <MainHeaderRight
      hiddenSearch={hiddenSearch}
    >
      {children}
    </MainHeaderRight>}
  </div>
}

export const CustomizeHeaderLeftDefault = ({ paths = [] }) => {
  const history = useNavigate()

  return <div className={styles.customizeHeaderLeftDefault}>
    <div className="customizeHeaderLeft-breadcrumb-back" onClick={() => { history(-1) }}>
      <Icon type="m-Vxing_zuo" />
    </div>
    <div style={{ marginLeft: '12px' }}>
      <Breadcrumb>
        {
          paths.map(item => <Breadcrumb.Item>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => {
                item.path && history(item.path)
              }}
            >
              {item.name}
            </span>
          </Breadcrumb.Item>)
        }
      </Breadcrumb>
    </div>
  </div>
}
